import React, { useEffect, useReducer, useState } from 'react'
import { Col, Container, Dropdown, DropdownButton, Row, Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component';
import { IoIosArrowRoundDown } from "react-icons/io";
import { BsCircleFill, BsThreeDotsVertical } from 'react-icons/bs';
import { Sidebar } from '../../Components/Sidebar';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';
import toast from 'react-hot-toast';
import { EditModal } from '../../Components/Modals/EditModal';
// Import the new ConsentManagementModal
import { ConsentManagementModal } from '../../Components/Modals/ConsentModals';
import { BsChevronLeft } from 'react-icons/bs';

import moment from 'moment';

function reducer(state, action){
    switch(action.type){
        case 'loading': {
            return {
                ...state,
                loader: action.loader
            }
        }
        case 'list': {
            return {
                ...state,
                list: action.list
            }
        }

        default:
            return state
    }
}

export const ManageConsent = () => {
    const [state, dispatch] = useReducer(reducer, {
        list: [],
        loader: false
    })
    
    // Updated state for modals
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showManagementModal, setShowManagementModal] = useState(false);
    const [modalMode, setModalMode] = useState(null); 
    const [consentActionData, setConsentActionData] = useState(null);

    const consentTablecolumns = [
        {
            name: 'Corporate Name',
            selector: row => row.gspUserData.name,
            sortable: true,
            cell: row => (
                <Link className="fw-semibold" to={`/consent-details/${row.gspUserData.id}`}>{row.gspUserData.name}</Link>
            )
        },
        {
            name: 'PAN Number',
            selector: row => row.gspUserData.pan,
            sortable: true,
            width: '130px'
        },
        {
            name: 'GST Number',
            selector: row => row.gspUserData.gstin,
            sortable: true,
        },
        {
            name: 'GSP Code',
            selector: row => row.gspUserData.gsp,
            sortable: true,
        },
        {
            name: 'Created On',
            selector: row => moment(row.gspUserData.created_at).format('DD/MM/YYYY'),
            sortable: true,
        },
        {
            name: 'Created By',
            selector: row => row.gspUserData.created_by_id,
            sortable: true,
        },
        {
            name: 'Verification Status',
            selector: row => row.gspUserData.is_active,
            sortable: true,
            cell: row => {
                const hasPartialRevocation = row.gspUserData.is_active && 
                    row.gspUserData.extra_data?.consent?.revoked_banks?.length > 0;
                const hasFutureRevoke = row.gspUserData.extra_data?.consent?.revoke_future_enabled;
                
                return (
                    <div className="d-flex flex-wrap align-items-center">
                        <BsCircleFill
                            className={`me-2 text-xs ${
                                row.gspUserData.is_active
                                    ? hasPartialRevocation ? 'text-warning' : 'text-success'
                                    : 'text-black-50 opacity-75'
                            }`}
                        />
                        <span className="me-2">
                            {row.gspUserData.is_active
                                ? hasPartialRevocation ? 'Partially Active' : 'Active'
                                : 'De-active'}
                        </span>
                        {hasFutureRevoke && (
                            <span className="badge bg-warning text-dark py-1 px-2 small me-1">
                                Future Revoke
                            </span>
                        )}
                    </div>
                );
            }
        },
        {
            name: 'Action',
            width: '71px',
            headerStyle: (selector, id) => {
                return {}
            },
            cell: row => (
                <>
                    <DropdownButton
                        id={`dropdown-button-drop-start`}
                        drop={'start'}
                        variant=""
                        bsPrefix='btn btn-transparent border-0 px-1'
                        title={<BsThreeDotsVertical />}
                    >
                        <Dropdown.Item eventKey="1" onClick={() => {
                            const d = { ...row.gspUserData };
                            // Map BE → FE field names
                            d.emailId = d.email ?? '';
                            d.mobileNumber = d.mobile_number ?? '';
                            d.validDate = d?.extra_data?.validuntill || d?.extra_data?.validUntil || null;
                            // IMPORTANT: blank the password for edit
                            d.password = "";
                            setEditData(d);
                            setShowEditModal(true);
                        }}>Edit Consent</Dropdown.Item>
                        <Dropdown.Divider className='my-1' />
                        {/* Updated logic to use the new modal */}
                        {row.gspUserData.is_active ? (
                            <Dropdown.Item eventKey="3" onClick={() => {
                                const hasRevokedBanks = row.gspUserData.extra_data?.consent?.revoked_banks?.length > 0;
                                const hasFutureRevoke = row.gspUserData.extra_data?.consent?.revoke_future_enabled;
                                const mode = hasRevokedBanks || hasFutureRevoke ? 'manage' : 'revoke';
                                setConsentActionData(row.gspUserData);
                                setModalMode(mode);
                                setShowManagementModal(true);
                            }}>Manage Consent</Dropdown.Item>
                        ) : (
                            <Dropdown.Item eventKey="4" onClick={() => {
                                setConsentActionData(row.gspUserData);
                                setModalMode('manage');
                                setShowManagementModal(true);
                            }}>Manage Consent</Dropdown.Item>
                        )}
                        {/* The 'Delete' functionality remains commented out as requested. */}
                        {/* 
                        <Dropdown.Divider className='my-1' />
                        <Dropdown.Item eventKey="2" onClick={() => {
                            toast((t) => (
                                <div>
                                    <div>Do you want to delete? <b style={{ fontSize: '14px'}}>{row.gspUserData.gstin}</b></div>
                                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'end', paddingRight: '30px;'}}> <button onClick={() => toast.dismiss(t.id)}>
                                        Cancel
                                    </button>
                                    <button onClick={() => {
                                        deleteConsent(row.gspUserData.id)
                                        toast.dismiss(t.id)
                                    }}>
                                        Confirm
                                    </button></div>
                                </div>
                            ), {
                                duration: 4000000,
                                style: {
                                    width: '350px'
                                },
                            });
                        }}>Delete</Dropdown.Item> 
                        */}
                    </DropdownButton>
                </>
            )
        },
    ];

    const sortIcon = <IoIosArrowRoundDown className='text-dark' />
    const paginationComponentOptions = {
        noRowsPerPage: true,
    }

    useEffect(() => {
       dispatch({
        type:'loading',
        loader: true
       })
       fetchData()
    }, []);

    const fetchData = () => {
        // 1. Retrieve the token directly from local storage.
        // We remove JSON.parse() to make it more robust.
        const token = localStorage.getItem('token');

        // The key from @rehooks/local-storage is just the string 'token', so this is correct.
        if (!token) {
            toast.error("Authentication error. Please log in again.");
            dispatch({ type: 'loading', loader: false });
            return;
        }

        // 2. Add the token to the request body.
        const payload = {
            // The backend expects the token value, not a JSON string.
            token: token 
        };

        axiosInstance().post('consent-api/getGspUserList', payload)
           .then((res) => {
            if([200].includes(res.data?.code)) {
                dispatch({
                    type: 'loading',
                    loader: false
                })
                dispatch({
                    type: 'list',
                    list: res.data.gspUserList
                })
            } else {
                toast.error(res.data?.message)
                dispatch({
                    type:'loading',
                    loader: false
                })
            }
           }).catch(err => {
                console.log(err);
                // Also handle potential errors from the catch block
                toast.error("Failed to fetch consent list.");
                dispatch({ type: 'loading', loader: false });
           })
    }


    /* The 'deleteConsent' function remains commented out as requested. */
    /* 
    const deleteConsent = (id) => {
        const promise = axiosInstance().post(
            'consent-api/gspUserDelete',
            {
                gspUserId: String(id)
            }
        )
        toast.promise(
            promise,
            {
                loading: 'Deleting...',
                success: (res) => {
                    if([200].includes(res.data?.code)) {
                        fetchData()
                        return <b>{res.data.message}</b>
                    } else {
                        return <b>{res.data.message}</b>
                    }
                },
                error: (err) => {
                    return <b>{err.toString()}</b>
                }
            },
            {
                // style: {
                //     minWidth: '350px',
                // },
                // success: {
                //     duration: 5000,
                //     icon: '🔥',
                // },
            }
        );
    }
    */

    const handleManagementModalClose = () => {
        setShowManagementModal(false);
        setModalMode(null);
    };

    return (
        <Container fluid className='px-4 py-5'>
            <Row>
                <Link to={'/home'} className='fw-bold mb-4 d-inline-block text-decoration-none'>
                    <BsChevronLeft className='me-1' />Back
                </Link>
                <Col md={3}>
                    <Sidebar
                        title={'Manage Consent'}
                        gradientBg={true}
                        ctaText={'Need help to manage consent?'}
                        ctaLink={'/faq'}
                    />
                </Col>
                <Col md={9}>
                    {
                        state.loader ? <div className='d-flex justify-content-center align-items-center' style={{height: '100%'}}>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div> :
                        <DataTable
                            columns={consentTablecolumns}
                            data={state.list}
                            sortIcon={sortIcon}
                            highlightOnHover
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={{
                                rows: {
                                    style: {
                                        minHeight: '60px',
                                        paddingTop: '8px',
                                        paddingBottom: '8px',
                                        marginBottom: '4px'
                                    }
                                },
                                cells: {
                                    style: {
                                        paddingTop: '12px',
                                        paddingBottom: '12px'
                                    }
                                }
                            }}
                        />
                    }
                </Col>
            </Row>
            <EditModal showOtpModal={showEditModal} setShowOtpModal={setShowEditModal} data={editData} fetchData={fetchData}/>
            
            {/* Render the updated modals */}
            {showManagementModal && (
                <ConsentManagementModal 
                    show={showManagementModal} 
                    handleClose={handleManagementModalClose} 
                    consentData={consentActionData} 
                    fetchData={fetchData}
                    mode={modalMode} 
                />
            )}
        </Container>
    )
}
